export default {
  getSettingsFailure: 'Unable to load your settings. Please try again.'
}



// WEBPACK FOOTER //
// ./src/settings/messages.js